var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGoToHome(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Icon_Home",
    "data-name": "Icon Home",
    xmlns: "http://www.w3.org/2000/svg",
    width: 35,
    height: 30,
    viewBox: "0 0 35 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_357",
    "data-name": "Caminho 357",
    d: "M34.084,9.724,18.771.349a2.49,2.49,0,0,0-2.542,0L.916,9.724a1.71,1.71,0,0,0-.508,2.616,2.43,2.43,0,0,0,3.051.437l.916-.561v15.91A2.049,2.049,0,0,0,6.562,30H28.438a2.049,2.049,0,0,0,2.188-1.875V12.215a4.008,4.008,0,0,0,2.185.91,2.314,2.314,0,0,0,1.782-.786A1.71,1.71,0,0,0,34.084,9.724ZM26.25,26.25H21.875V20.625c0-2.071-1.959-3.75-4.375-3.75s-4.375,1.679-4.375,3.75V26.25H8.75V9.536L17.5,4.179l8.75,5.357Z",
    transform: "translate(0 0)",
    fill: "#fff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoToHome);
export default __webpack_public_path__ + "static/media/goToHome.42b407c1f466cdec42fad6aa314547ca.svg";
export { ForwardRef as ReactComponent };